import React, { useContext } from 'react';
import { Routes, Route, Navigate, useResolvedPath } from 'react-router-dom';
import CrossSellRoutes from 'Sell/CrossSell/Router/routes';
import ItemList from 'Sell/CrossSell/Item/List/ItemList';
import UpsertItem from 'Sell/CrossSell/Item/Upsert/UpsertItem';
import CrossSellList from 'Sell/CrossSell/CrossSell/List/CrossSellList';
import Reports from 'Sell/CrossSell/Reports/Reports';
import ProtectedRoute from './ProtectedRoute';
import { AppContext } from 'App.context';

export default function NestedRoutes() {
  const { appState } = useContext(AppContext);
  const resolved = useResolvedPath('.');
  const basePath = resolved.pathname;

  const defaultRoute =
    appState.role === 'owner' || appState.role === 'admin' || appState.superUser
      ? `${basePath}${CrossSellRoutes.itemsList}`
      : `${basePath}${CrossSellRoutes.crossSellsList}`;

  return (
    <Routes>
      <Route
        path={`${CrossSellRoutes.itemsList}`}
        element={
          <ProtectedRoute>
            <ItemList />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${CrossSellRoutes.itemCreate}`}
        element={
          <ProtectedRoute>
            <UpsertItem />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${CrossSellRoutes.itemUpsert}`}
        element={
          <ProtectedRoute>
            <UpsertItem />
          </ProtectedRoute>
        }
      />
      <Route path={`${CrossSellRoutes.crossSellsList}`} element={<CrossSellList />} />
      <Route path={`${CrossSellRoutes.reports}`} element={<Reports />} />
      <Route path="*" element={<Navigate to={defaultRoute} replace />} />
    </Routes>
  );
}
